// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"bf3ab20b","453":"f721032f"}[chunkId] + ".chunk.js";
};